export const SOLARRECHNER_URL =
  "https://portal.reonic.de/public/0bc6e4bf-b8dd-4190-af4f-653b8ce5d9a0/energyhouse?frontendId=6a3d9b9d-b62a-41ae-9404-786f10d83a16&utm_source=website&utm_medium=lovable_embed&utm_campaign=wm_website";

export type NavItem = {
  label: string;
  to?: string;
  children?: { label: string; to: string }[];
};

export const NAV: NavItem[] = [
  { label: "Startseite", to: "/" },
  { label: "Paketpreise\n& Angebot", to: "/anlage-konfigurieren" },
  { label: "Mehr als\nnur PV", to: "/mehr-als-pv" },
  { label: "Optimierung von\nBestandsanlagen", to: "/bestandsanlagen" },
  { label: "Referenz-\nanlagen", to: "/referenzen" },
  {
    label: "Sonstiges",
    children: [
      { label: "Unsere Hersteller", to: "/empfehlungen" },
      { label: "Aktuelles", to: "/aktuelles" },
      { label: "Mieterstrom", to: "/mieterstrom" },
      { label: "Bausteine", to: "/produktportfolio" },
      { label: "Notstrom", to: "/notstrom" },
      { label: "FAQ", to: "/faq" },
      { label: "Über uns", to: "/ueber-uns" },
    ],
  },
];

export const COMPANY = {
  name: "WM erneuerbare Energien GmbH",
  street: "Mühlstraße 8",
  city: "69234 Dielheim",
  phone: "+49 1515 0559085",
  email: "kontakt@wmee.de",
};
